import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    isProcessing: false,
    inputCsr: "",
    decodedInputCsr: {},
    inputKey: "",
    errors: []
};

const slice = createSlice({
    name: "certificateCsr",
    initialState,
    reducers: {
        setProcessing(state, action) {
            const {isProcessing} = action.payload;
            state.isProcessing = isProcessing;
        },
        setInput(state, action) {
            const {inputCsr, decodedInputCsr, inputKey} = action.payload;
            state.inputCsr = inputCsr;
            state.inputKey = inputKey;
            state.decodedInputCsr = decodedInputCsr;
        },
        resetInput(state, action) {
            state.inputCsr = initialState.inputCsr;
            state.inputKey = initialState.inputKey;
            state.decodedInputCsr = initialState.decodedInputCsr;
            state.errors = initialState.errors;
        },
        setErrors(state, action) {
            const {errors} = action.payload;
            state.errors = errors;
        }
    }
});

export const reducer = slice.reducer;

export const setProcessing = isProcessing => dispatch => {
    dispatch(slice.actions.setProcessing({isProcessing}));
};

export const setInput = (inputCsr, decodedInputCsr, inputKey) => dispatch => {
    dispatch(slice.actions.setInput({inputCsr, decodedInputCsr, inputKey}));
};

export const resetInput = () => dispatch => {
    dispatch(slice.actions.resetInput());
};

export const setErrors = errors => dispatch => {
    dispatch(slice.actions.setErrors({errors}));
};
